// The Miro icon the predefined `miro` MCP server already uses, in
// packages/integrations/agentic/shared/src/mcp/saas/miro.ts.
export const MiroAiIconUrl =
  "https://framerusercontent.com/images/6FBG66PBxjV2QFaDfIdUi5mi9A.png";
